module.exports = " <div class=row> <ul class=\"nav nav-pills admin-product-nav nav-pills-black\"> <li role=presentation class=active><a class=no-margin data-toggle=tab href=#General>General</a></li> <li role=presentation><a class=no-margin data-toggle=tab href=#Shipping>Envío</a></li> <li role=presentation><a class=no-margin data-toggle=tab href=#Complements>Complementos</a></li> <li style=\"float: right\" role=presentation> <input type=submit class=\"btn btn-blue\" value=Guardar></li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Admin-product-navbar.vue
// module id = 538
// module chunks = 0